import { Flex, LinkButton, Text } from "@hopper-ui/components";
import { AngleRightIcon } from "@hopper-ui/icons";
import { useTrackButtonClicked } from "@sg-protect/shell";
import { usePaths } from "../../paths.ts";
import { useCanOpenActivityLog } from "./useCanOpenActivityLog.ts";
import styles from "./ActivityPanel.module.css";

export function ViewActivityLogLink() {
    const paths = usePaths();
    const canOpenActivityLog = useCanOpenActivityLog();
    const trackButtonClicked = useTrackButtonClicked();

    if (!canOpenActivityLog) {
        return null;
    }

    const handlePress = () => {
        trackButtonClicked("View Activity Log", "Activity Center");
    };

    return (
        <Flex justifyContent="end" className={styles.footer}>
            <LinkButton
                variant="ghost-primary"
                size="sm"
                href={paths.activityLog}
                onPress={handlePress}
                marginTop="core_0"
                data-public
            >
                <Text>View Activity log</Text>
                <AngleRightIcon size="sm" slot="end-icon" />
            </LinkButton>
        </Flex>
    );
}
